import { render, staticRenderFns } from "./FeeDesc.vue?vue&type=template&id=139b2960&"
import script from "./FeeDesc.vue?vue&type=script&lang=js&"
export * from "./FeeDesc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports